import AbstractComponent from './AbstractComponent';
import gsap from 'gsap';
import EmitterManager from '../managers/EmitterManager';
import { REVEALS } from 'core/Events';

class RevealGroup extends AbstractComponent {
  constructor() {
    super(...arguments);
  }

  bind() {
    super.bind();
    this.handleReveal = this.handleReveal.bind(this);
    this.handleIntersection = this.handleIntersection.bind(this);
  }

  getUI() {
    const ui = super.getUI();
    ui.$reveals = ui.$element.querySelectorAll('.reveal-group__item');
    return ui;
  }

  initializeBeforeEvents() {
    EmitterManager.on(REVEALS, this.handleReveal);

    const observer = new IntersectionObserver(this.handleIntersection, {
      threshold: 0.0,
      rootMargin: '0% 0px -40% 0px',
    });

    observer.observe(this.ui.$element);

    this.observer = observer;
  }

  handleReveal() {
    this.shouldReveal = true;
    this.animateIn();
  }

  handleIntersection([entry]) {
    const { isIntersecting, intersectionRatio } = entry;
    const isInViewport = isIntersecting || intersectionRatio > 0;

    if (isInViewport) {
      this.isInViewport = isInViewport;
      this.animateIn();
    }
  }

  animateIn() {
    if (!this.isInViewport || !this.shouldReveal) return;

    this.observer.disconnect();

    const { $reveals } = this.ui;

    gsap
      .timeline()
      .to($reveals, 1, { opacity: 1, ease: 'cubic.out', stagger: 0.2 }, 0)
      .to($reveals, 1.5, { y: 0, ease: 'expo.out', stagger: 0.2 }, 0);
  }
}

export default RevealGroup;
